import classNames from "classnames";
import React, { Fragment, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * Hook para el uso del componnete de steps
 * @param {*} param0
 * @returns
 */
export const useStepIndicator = ({ steps, currentStep, steplong }) => {
  const [_currentStep, setCurrentStep] = useState(currentStep ?? 1);
  const [called, setCalled] = useState(false);
  const _setCurrentStep = useCallback((step) => {
    setCurrentStep(step);
    setCalled(true);
  }, []);
  return {
    currentStep: _currentStep,
    setCurrentStep: _setCurrentStep,
    called,
    bind: {
      currentStep: _currentStep,
      steps: steps,
      steplong: steplong ?? "w-[24px]",
    },
  };
};

/**
 * Componnete de steps
 * @param {*} param0
 * @returns
 */
export const StepIndicator1 = ({ steps, currentStep, steplong }) => {
  const _steps = Array.from({ length: steps }, (_, index) => index);
  return (
    <div className="flex items-center justify-center">
      {_steps.map((step, index) => (
        <Fragment key={index}>
          <div
            key={index}
            className={`flex items-center justify-center w-[20px] h-[20px] rounded-full border-2 ${
              currentStep < index + 1
                ? "bg-Grey-700 border-Grey-700"
                : "bg-LightBlue-500 border-LightBlue-500"
            }`}
          >
            <span
              className={`text-[12px] ${
                currentStep === index ? "text-white" : "text-[#D2D2D2]"
              } font-bold`}
            >
              {index + 1}
            </span>
          </div>
          {/* //linea horizontal que une el paso actual con el siguien, como si fueran nodos  de una lista, el primero no se une con un anterior y el ultimo no se une con un posterior */}
          {_steps?.length === index + 1 ? null : (
            <div
              key={"line" + index}
              className={`flex items-center justify-center ${
                steplong ?? "w-[24px]"
              } h-[0px] border-t-2 ${
                currentStep <= index + 1
                  ? "bg-Grey-700 border-Grey-700"
                  : "bg-LightBlue-500 border-LightBlue-500"
              }`}
            ></div>
          )}
        </Fragment>
      ))}
    </div>
  );
};

/**
 * Componnete de steps cuando no estan separados poruna linea, tiene un texto
 * @param {*} param0
 * @returns
 */
export const StepIndicator2 = ({ steps, currentStep }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center h-full w-full overflow-x-auto whitespace-nowrap py-2">
      {steps.map((step, index) => (
        <div key={index} className="flex w-fit items-center flex-shrink-0">
          <div
            key={index}
            className={classNames(
              "flex items-center justify-center min-w-[32px] h-[32px] rounded-full border-2  ",
              {
                "bg-LightBlue-500 border-LightBlue-500": currentStep > index,
                "bg-Grey-700 border-Grey-700": currentStep <= index,
              }
            )}
          >
            <span
              className={classNames("text-[12px] font-bold ", {
                "text-white": currentStep === index,
                "text-[#D2D2D2]": currentStep !== index,
              })}
            >
              {index + 1}
            </span>
          </div>
          <div className={`text-[16px] text-[white] m-0 p-0 pl-2 pr-8 h-fit`}>
            {t(step)}
          </div>
        </div>
      ))}
    </div>
  );
};

/**
 * Componnete de steps, puede ser de dos tipos, con linea o sin linea, se determina si steps es un array o un numero
 * @param {*} param0
 * @returns
 */
export const StepIndicator = ({ steps, currentStep, steplong }) => {
  if (steps?.length) {
    return <StepIndicator2 steps={steps} currentStep={currentStep} />;
  } else {
    return (
      <StepIndicator1
        steps={steps}
        currentStep={currentStep}
        steplong={steplong}
      />
    );
  }
};


